import * as React from 'react';
import _ from 'lodash';
import { Grid, Dropdown, Popup, Icon, Button } from 'semantic-grab-ui/src';
import { getNodePopupContent } from 'omega-rtc/utils/trident-node-utils';
import { CampaignWidgetProps } from 'types/ts/campaigns';
import { nodeTypes } from 'data/trident-types';
import { renderDropdownItem, getNodeTypeChildOptions } from "components/form/trident-campaigns/util";
import { getDefaultNodeName } from 'omega-rtc/utils/trident-node-utils';

export default class ScheduleWidget extends React.Component<CampaignWidgetProps> {
  render() {
    const { model, currentNodeKey } = this.props;

    const gridStyle = {
      width: 'auto',
    };
    const gridStyleForAddButton = {
      width: 'auto',
      top: 45,
      right: 25,
    };
    const addButtonSize = {
      fontSize: '1.5em',
      marginTop: '-10px',
      color: '#3498DB',
    };
    const buttonStyle = {
      height: 100,
      width: 105,
      transform: 'skew(-10deg)',
      backgroundColor: 'cornsilk',
      border: '1px solid #76D7C4',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    };
    const buttonStyleClicked = {
      ...buttonStyle,
      backgroundColor: 'yellow',
    };
    const noOfChildren = _.get(model.nodes[currentNodeKey], 'children', []).length;
    const renderAddButton = noOfChildren === 0;
    const childOptions = getNodeTypeChildOptions(model.targetUserType,nodeTypes.schedule);
    const defaultName = getDefaultNodeName(currentNodeKey, nodeTypes.schedule, _.get(model, 'nodesOccMap'));

    return (
      <Grid>
        <Grid.Column style={gridStyle}>
          <Popup
            trigger={
              <Button style={this.props.clickedNode === this.props.currentNodeKey ? buttonStyleClicked : buttonStyle} onClick={() => this.props.handleNodePreview([currentNodeKey], currentNodeKey)}>
                {_.get(model.nodes[currentNodeKey], 'name', defaultName) || defaultName}
              </Button>
            }
            content={getNodePopupContent(this.props.model, 'name', this.props.currentNodeKey, defaultName)}
          />
        </Grid.Column>
        {(renderAddButton) &&
        <Grid.Column style={gridStyleForAddButton}>
          <Dropdown icon="plus square" floating basic className="icon" style={addButtonSize}>
            <Dropdown.Menu>
              {childOptions.map(option =>
                renderDropdownItem(`Add ${option}`, () => this.props.handleAddNode(option, currentNodeKey, [currentNodeKey]))
              )}
            </Dropdown.Menu>
          </Dropdown>
        </Grid.Column>
        }
      </Grid>
    );
  }
}
